import angular from 'angular';
import AllContactsService from './all-contacts/all-contacts-service';
import AllContactsCtrl from './all-contacts/all-contacts-controller';

export default angular.module('mapmycustomersApp.contacts', [])
  .factory('AllContactsService', AllContactsService)
  .controller('AllContactsCtrl', AllContactsCtrl)
  .name;
